import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import HtmlDiff from 'htmldiff-js';
import PropTypes from 'prop-types';
import {
  getMinimumValue,
  PredeterminedInput,
} from '../../../components/forms/eq-association-table-elements';
import { useFvsRequirements } from '../requirements/requirements-provider';

const MinimumsHighlighter = ({
  row: {
    original: {
      inputType,
      criteria,
      unit,
      lowerBound,
      upperBound,
      preDefinedValue,
      change,
    },
  },
}) => {
  const { doHighlightChanges } = useFvsRequirements();

  let currentValue = getMinimumValue({
    inputTypeCode: inputType?.code,
    criteriaTitle: criteria?.title,
    unitTitle: unit?.title,
    lowerBound,
    upperBound,
  });

  if (!doHighlightChanges || !change) {
    if (inputType?.code?.toLowerCase() === 'p') {
      return <PredeterminedInput preDefinedValue={preDefinedValue} />;
    }
    if (!currentValue) {
      return <span data-testid="empty-text">&ndash;</span>;
    }
    return currentValue;
  }

  // if there is change
  let fieldChange = change.differences?.differences?.find(
    (d) => d?.path.indexOf('inputTypeCode') >= 0,
  );
  const prevInputType = fieldChange?.lhs
    ? fieldChange?.lhs.toLowerCase()
    : inputType?.code?.toLowerCase();

  fieldChange = change.differences?.differences?.find(
    (d) => d?.path.indexOf('criteriaCode') >= 0,
  );
  const prevCriteria = fieldChange?.lhs || criteria?.title;

  fieldChange = change.differences?.differences?.find(
    (d) => d?.path.indexOf('unitCode') >= 0,
  );
  const prevUnit = fieldChange?.lhs || unit?.title;

  fieldChange = change.differences?.differences?.find(
    (d) => d?.path.indexOf('lowerBound') >= 0,
  );
  const prevLowerBound = fieldChange?.lhs || lowerBound;

  fieldChange = change.differences?.differences?.find(
    (d) => d?.path.indexOf('upperBound') >= 0,
  );
  const prevUpperBound = fieldChange?.lhs || upperBound;

  let prevPreDefinedValue = preDefinedValue?.value?.join(', ');
  const fieldChanges = change.differences?.differences?.filter(
    (d) => d?.path.indexOf('preDefinedValue') >= 0,
  );
  if (fieldChanges) {
    fieldChanges.forEach((f) => {
      prevPreDefinedValue = prevPreDefinedValue?.replace(f?.rhs, f?.lhs);
    });
  } else {
    prevPreDefinedValue = preDefinedValue?.value?.join(', ');
  }

  let previousValue = getMinimumValue(
    {
      inputTypeCode: prevInputType,
      criteriaTitle: prevCriteria,
      unitTitle: prevUnit,
      lowerBound: prevLowerBound,
      upperBound: prevUpperBound,
    },
    '',
  );

  if (inputType?.code?.toLowerCase() === 'p' && prevInputType === 'p') {
    currentValue = preDefinedValue?.value?.join(', ');
    previousValue = prevPreDefinedValue;
  }

  if (inputType?.code?.toLowerCase() === 'p' && prevInputType !== 'p') {
    return <PredeterminedInput preDefinedValue={preDefinedValue} />;
  }
  return ReactHtmlParser(
    `<div>${HtmlDiff.execute(previousValue ?? '', currentValue ?? '')}</div>`,
  );
};

MinimumsHighlighter.propTypes = {
  row: PropTypes.shape(Object).isRequired,
};

export default MinimumsHighlighter;
